import {
  BusinessMetaContext,
  CatalogDataContext,
  ProductsWritersContext,
  RestaurantOpsDataContext,
  RecipesDataContext,
  PurchasesDataContext,
  InventoryValuationContext,
  SalesDataContext,
  SalesWritersContext,
  CustomersDataContext,
  CustomersWritersContext,
  SuppliersDataContext,
  OrdersDataContext,
  ExpensesDataContext,
  PaymentsDataContext,
  CashRegisterDataContext,
  OperationsDataContext,
  SyncDataContext
} from '../../../contexts/dataContextSlices';

/**
 * Slice providers only — no merged DataContext bridge.
 * A former merge-all bridge re-rendered the entire shell on any slice change.
 */
export function DataContextProviders({ slices, children }) {
  const {
    meta,
    catalog,
    catalogWriters,
    restaurantOps,
    recipesProduction,
    purchases,
    inventoryValuation,
    sales,
    salesWriters,
    customers,
    customersWriters,
    suppliers,
    orders,
    expenses,
    payments,
    cashRegister,
    operations,
    sync
  } = slices;

  return (
    <BusinessMetaContext.Provider value={meta}>
      <ProductsWritersContext.Provider value={catalogWriters}>
        <CatalogDataContext.Provider value={catalog}>
          <RestaurantOpsDataContext.Provider value={restaurantOps}>
            <RecipesDataContext.Provider value={recipesProduction}>
              <PurchasesDataContext.Provider value={purchases}>
                <InventoryValuationContext.Provider value={inventoryValuation}>
                  <SalesWritersContext.Provider value={salesWriters}>
                    <SalesDataContext.Provider value={sales}>
                      <CustomersWritersContext.Provider value={customersWriters}>
                        <CustomersDataContext.Provider value={customers}>
                          <SuppliersDataContext.Provider value={suppliers}>
                            <OrdersDataContext.Provider value={orders}>
                              <ExpensesDataContext.Provider value={expenses}>
                                <PaymentsDataContext.Provider value={payments}>
                                  <CashRegisterDataContext.Provider value={cashRegister}>
                                    <OperationsDataContext.Provider value={operations}>
                                      <SyncDataContext.Provider value={sync}>
                                        {children}
                                      </SyncDataContext.Provider>
                                    </OperationsDataContext.Provider>
                                  </CashRegisterDataContext.Provider>
                                </PaymentsDataContext.Provider>
                              </ExpensesDataContext.Provider>
                            </OrdersDataContext.Provider>
                          </SuppliersDataContext.Provider>
                        </CustomersDataContext.Provider>
                      </CustomersWritersContext.Provider>
                    </SalesDataContext.Provider>
                  </SalesWritersContext.Provider>
                </InventoryValuationContext.Provider>
              </PurchasesDataContext.Provider>
            </RecipesDataContext.Provider>
          </RestaurantOpsDataContext.Provider>
        </CatalogDataContext.Provider>
      </ProductsWritersContext.Provider>
    </BusinessMetaContext.Provider>
  );
}
